import { useAgent, useTest } from '../filters';
import { Ng1DrillDownButton } from './Ng1DrillDownButton';

export default function Ng1DrillDownAction() {
    const agent = useAgent();
    const test = useTest();

    return <Ng1DrillDownButton agent={agent} test={test} />;
}
